import React from 'react'
import { StyledRadioInput, Props } from './styled'

export const RadioInput: React.FC<Props> = (props: Props) => {
  return <StyledRadioInput {...props} />
}
